<app-filters-dialog-frame>
  @if (form) {
    <form [formGroup]="form" preventFormSubmit>
      <div [class]="formGridStyle">
        <app-input
          labelKey="code"
          formControlName="code"
          [formGroup]="form"
        ></app-input>
        <app-input
          labelKey="orders.form.hpInvoiceCode"
          formControlName="hp_invoice_code"
          [formGroup]="form"
          onlyNumbers
          [isFloatNumber]="false"
        ></app-input>
        <app-select
          labelKey="customers.form.saleLine"
          [formGroup]="form"
          formControlName="sales_line"
          [options]="saleLineOptions"
        ></app-select>
        <app-date-picker
          labelKey="createdDateMin"
          formControlName="created_date_min"
          [formGroup]="form"
        ></app-date-picker>
        <app-date-picker
          labelKey="createdDateMax"
          formControlName="created_date_max"
          [formGroup]="form"
        ></app-date-picker>
        <app-select
          labelKey="step"
          [formGroup]="form"
          formControlName="step"
          [options]="stepOptions"
          [multiple]="true"
          selectOptionsTranslatePrefix="enums.StepEnum"
        ></app-select>
        @if (userRoles && userRoles?.includes(Roles.ViewSellerFilter)) {
          <app-select
            labelKey="seller"
            [formGroup]="form"
            [isAutocomplete]="true"
            formControlName="seller_id"
            [options]="sellersOptions"
            [loading]="!sellersOptions.length"
          ></app-select>
        }
        <app-select
          labelKey="representative"
          [formGroup]="form"
          [isAutocomplete]="true"
          formControlName="person_id"
          [options]="representativesOptions"
          [loading]="!representativesOptions.length"
        ></app-select>
        <app-select
          labelKey="customer"
          [formGroup]="form"
          [isAutocomplete]="true"
          formControlName="customer_id"
          [options]="customersOptions"
          [loading]="!customersOptions.length"
        ></app-select>
        <app-select
          labelKey="orders.filters.buyStatus"
          [formGroup]="form"
          formControlName="bought"
          [options]="buyStatusOptions"
        ></app-select>
        <app-nested-select
          [hasSearchOption]="true"
          firstTabText="searchProduct"
          secondTabText="productsList"
          labelKey="orders.form.products.product"
          [formGroup]="form"
          formControlName="product"
          [dataTree]="categoriesWithAllProductsTree || []"
          [flattenData]="allProducts || []"
          [loading]="categoriesWithAllProductsTree.length === 0"
        ></app-nested-select>
        <app-select
          labelKey="orders.form.deliveryMethod"
          [formGroup]="form"
          formControlName="delivery_method"
          [options]="deliveryMethodOptions"
          selectOptionsTranslatePrefix="enums.DeliveryMethodEnum"
        ></app-select>
        <app-select
          labelKey="orders.form.paymentMethod"
          [formGroup]="form"
          formControlName="payment_method"
          [options]="paymentMethodOptions"
          selectOptionsTranslatePrefix="enums.PaymentMethodEnum"
        ></app-select>
        <app-select
          labelKey="orders.form.paymentStatus"
          [formGroup]="form"
          formControlName="payment_status"
          [options]="paymentStatusOptions"
          selectOptionsTranslatePrefix="enums.PaymentStatusEnum"
        ></app-select>
        <app-select
          labelKey="orders.filters.answeredStatus"
          [formGroup]="form"
          formControlName="answered"
          [options]="answeredStatusOptions"
        ></app-select>
        <app-select
          labelKey="callFrom"
          [formGroup]="form"
          formControlName="did_we_contact"
          [options]="didWeContactOptions"
        ></app-select>
        <app-select
          labelKey="purchaseType"
          [formGroup]="form"
          formControlName="in_person_order"
          [options]="purchaseTypeOptions"
        ></app-select>
        <app-select
          labelKey="orders.filters.archivedStatus"
          [formGroup]="form"
          formControlName="archived"
          [options]="archivedOptions"
        ></app-select>
        <app-select
          labelKey="orders.filters.customerStatus"
          [formGroup]="form"
          formControlName="new_customer"
          [options]="customerStatusOptions"
        ></app-select>
        <app-select
          labelKey="orders.form.notPurchasedReason"
          [formGroup]="form"
          formControlName="not_purchased_reason"
          [options]="notPurchasedReasonOptions"
          selectOptionsTranslatePrefix="enums.NotPurchasedReasonEnum"
        ></app-select>
        <app-date-picker
          labelKey="orders.filters.deliveryDateMin"
          formControlName="delivery_date_min"
          [formGroup]="form"
        ></app-date-picker>
        <app-date-picker
          labelKey="orders.filters.deliveryDateMax"
          formControlName="delivery_date_max"
          [formGroup]="form"
        ></app-date-picker>
      </div>
      <div class="flex w-full justify-end gap-2 mt-4">
        <button mat-stroked-button color="primary" (click)="reset()">
          {{ "removeFilters" | translate }}</button
        ><button
          mat-flat-button
          color="primary"
          class="!text-white"
          (click)="submit()"
        >
          {{ "submit" | translate }}
        </button>
      </div>
    </form>
  }
</app-filters-dialog-frame>
